// reusable selectors for auth Slices
import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {ProfileSliceInterface} from "../reducers/profileSlice";

const useEditProfileSelectors = () => {

  const loading = useSelector<RootSliceType, ProfileSliceInterface["loading"]>(
    (state) => state.profileSlice.loading
  );


  return {
    loading
  };
};

export default useEditProfileSelectors;
